import { Component, Input } from '@angular/core';
import { IResponsible } from '@shared/interfaces';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { AdminService } from '../../../../admin.service';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-responsible-item',
    templateUrl: './admin-responsible-item.component.html',
    styleUrls: ['./admin-responsible-item.component.scss'],
    standalone: false
})
export class AdminResponsibleItemComponent extends AdminActionsDirective {
    responsible: string;
    specialists: string;

    @Input() index: number;

    private _item: IResponsible;

    get item(): IResponsible {
        return this._item;
    }

    @Input() set item(val: IResponsible) {
        this._item = val;
        this.responsible = val.responsible ? val.responsible.map(e => e.fullName).join(', ') : null;
        this.specialists = val.specialists ? val.specialists.map(e => e.fullName).join(', ') : null;
    }

    constructor(adminService: AdminService, dialogService: DialogService, moduleService: ModuleService) {
        super(adminService, dialogService, moduleService);
    }
}
